var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUtensils(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentBackgroundColor;}.cls-1,.cls-2{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.37,34.7,97.93,185c0,4.41,4.21,8,9.34,8h0c5.14,0,9.35-3.62,9.35-8l-6.87-61.92S138.64,82.48,97.37,34.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.09,154.53,175.51,40.89c.64-3.33-1.9-6.65-5.65-7.37h0c-3.75-.72-7.34,1.42-8,4.75L148.11,152.09S137.36,239.48,154.09,154.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.09,153.74l-19.58-114c-.56-3.35-4.1-5.57-7.87-4.94h0c-3.76.63-6.38,3.89-5.82,7.24l26.81,111.47S173.05,239.19,159.09,153.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.12,82.89,76.58,35.81h-30L44.2,82.89c0,5.07,5.22,9.41,11.9,11L52.32,185c0,4.41,4.21,8,9.34,8h0c5.14,0,9.34-3.62,9.34-8L68.3,93.68C74.48,91.9,79.12,87.72,79.12,82.89Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 56.48,
    y1: 36,
    x2: 56.48,
    y2: 68.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 66.58,
    y1: 36,
    x2: 66.58,
    y2: 68.58
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtensils);
export default __webpack_public_path__ + "static/media/UTENSILS.532d0a236bd18455b5399be9f6d2e2f2.svg";
export { ForwardRef as ReactComponent };